import {auth} from "../../services/Auth";
import Store from "../../store";
import {useRole} from "../../hooks/useRole";
import {useUser} from "../../hooks/useUser";

const {isCreator, isBrand} = useRole();
const {isRegistrationFinished} = useUser();

const checkAndGoNext = ({next, to, router}) => {
  if (!isRegistrationFinished.value) {
    if (isBrand.value && 'register.brand.setup' !== to.name) {
      router.push({ name: 'register.brand.setup'});
      return next(false);
    }

    if (isCreator.value && 'register.creator.setup' !== to.name) {
      router.push({ name: 'register.creator.setup'});
      return next(false);
    }
  }

  if (isCreator.value) {
    router.push({ name: 'creator.page'});
    return next(false);
  }

  return next();
}

export default async function authenticated({next, to, from, router}) {
  if (Store.getters['auth/isAuthenticated']) {
    return checkAndGoNext({next, to, from, router});
  }

  try {
    await auth();

    if (Store.getters['auth/isAuthenticated']) {
      return checkAndGoNext({next, to, from, router});
    }
  } catch (e) {

  }


  router.push({ name: 'login', query: { redirect: to.fullPath }});
  return next(false);
}
